import {ESLMediaQuery} from '@exadel/esl/modules/esl-media-query/core';
import {ESLEventUtils} from '@exadel/esl/modules/esl-utils/dom';
import {listen} from '@exadel/esl/modules/esl-utils/decorators';

import type {ESLMedia, ESLMediaHookEvent} from '@exadel/esl/modules/esl-media/core';

export class HPEMediaRestriction {
  static init(): void {
    // Use window as a host to ensure single subscription instance
    ESLEventUtils.subscribe(window, this.onReducedMotionChange);
    ESLEventUtils.subscribe(window, this.onPlayListener);
  }

  @listen({event: 'change', target: ESLMediaQuery.for('@reduced-motion')})
  protected static onReducedMotionChange(e: MediaQueryListEvent): void {
    const action = e.matches ? 'suspend' : 'release';
    ESLEventUtils.dispatch(window, 'esl:media:managedaction', {detail: {action}});
  }

  @listen({event: 'esl:media:before:play', target: window})
  protected static onPlayListener(e: ESLMediaHookEvent): void {
    if (!ESLMediaQuery.for('@reduced-motion').matches) return;
    const $media = e.target as ESLMedia;
    if (($media.mediaType === 'video' || $media.muted) && e.initiator !== 'user') {
      e.preventDefault();
    }
  }
}
